export enum HubspotStatus {
    ACTIVE = 1, // Activo
    NA = 2, // N/A
    TRIAL_EXPIRED = 3, // Trial Expirado
    FREE_TRIAL_REMAINING = 4, // Free Trial {10} días restantes
}
